<template>
    <mu-content-block>
        <mu-input type="text" :to-add-line="true" holder="图片验证码" v-model="picture_code" v-if="pictureValidate">
            <mu-button @click="getPicCode">
                <img :src="pictureCode" class="picCode"/>
            </mu-button>
        </mu-input>
        <mu-input type="number" :to-add-line="true" holder="验证码" v-model="sms_code">
            <mu-button @click="getSmsCode">
                <mu-countdown text="发送验证码" algin="'right'" :during="59" :active.sync="timmer" format="S 秒后重新发送" @change="timmerChange"></mu-countdown>
            </mu-button>
        </mu-input>
    </mu-content-block>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import * as utils from '../../../utils/utils';
    import { regexp } from '../../../utils/config';
    import webapi from '../../../request/webapi';
    export default {
        name: "smsCode",
        data: () => {
            return {
                picture_code: '',
                pictureValidate: false,
                sms_code: '',
                timmer: false,
                pictureCode: '',
                vId: '',
                vType: '',
                vContent: ''
            }
        },
        computed: {
            ...mapGetters(['common/common']),
        },
        props: {
            mobile: String,
        },
        watch: {
            sms_code: function (val) {
                // console.log(val)
                this.$emit('changeSmscode', val);
            }
        },
        methods: {
            // 获取短信验证码
            async getSmsCode() {
                if (this.timmer) {
                    return false;
                }
                const result = utils.validate([{
                    reg: regexp.mobile,
                    data: this.mobile,
                    msg: '手机号格式有误，请重新输入'
                }]);
                if (result !== true) {
                    return this.$showToast({ text: result });
                }
                let getCodeDate = {
                    mobile: this.mobile,
                    pid: this['common/common'].appJson.comm.pid,
                    clientType: this['common/common'].appJson.comm.type
                };

                if (this.pictureValidate) {
                    getCodeDate = Object.assign({}, getCodeDate,
                        { vId: this.vId, vType: this.vType, vContent: this.picture_code });
                }
                try {
                    let smsCode = await webapi.user.getSmsCode(getCodeDate);
                    if (smsCode.status === 1 && smsCode.errorcode === 709) {
                        await this.getPicCode();
                        this.pictureValidate = true;
                        return;
                    }
                    if (smsCode.status === 1) {
                        return this.$showAlert({ text: smsCode.message });
                    }
                    this.timmer = true;
                }
                catch (e) {
                    window.alert(JSON.stringify(e));
                }
            },
            // 获取图片验证码
            async getPicCode() {
                const getCodeDate = {
                    mobile: this.mobile,
                    pid: this['common/common'].appJson.comm.pid,
                    clientType: this['common/common'].appJson.comm.type
                };
                const pictureData = await webapi.user.getPicCode(getCodeDate);
                this.pictureCode = 'data:image/png;base64,' + pictureData.data.vContent;
                this.vType = 1;
                this.vId = pictureData.data.vId;
            },
            timmerChange(val) {
                this.timmer = val;
            },
        }
    }
</script>

<style scoped>
    .picCode {
        width: 10rem;
        height: 3.6rem;
    }
</style>